const bmsUserMenuProps = {
  ucCommonConfig: {
    type: Object,
    default: void 0
  },
  loginType: {
    type: String,
    default: ""
  },
  isFreeAccount: {
    type: Boolean,
    default: false
  },
  isLogin: {
    type: Boolean,
    default: false
  },
  hasSaas: {
    type: Boolean,
    default: false
  },
  name: {
    type: String,
    default: ""
  },
  uncompletedCount: {
    type: Number,
    default: 0
  },
  buyLink: {
    type: String,
    default: "/solution/detail/3000/4000"
  },
  saasLink: {
    type: String,
    default: "/saas"
  },
  myOrderLink: {
    type: String,
    default: "/mall/order/list"
  },
  myCustomizeLink: {
    type: Array,
    default: void 0
  }
};

export { bmsUserMenuProps };
//# sourceMappingURL=bms-user-menu2.js.map
